export default __webpack_public_path__ + "static/social-index_en-20cd9ddc168e075a58d9e42c592efedd.png";